<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Arrive Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="classCode" :showName="false" /> </span>

				<em class="lt_text">Carton</em>
				<span class="int_type_no_border mgr_5"> <input type="number" v-model="carton" class="tbl_int ssm_int" /> </span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="fixed-table-container">
			<div class="mgb_20" style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">Carton</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.carton | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Qty</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.qty | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Amount</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.amount | toCurrency" />
					</label>
				</div>
			</div>
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="output">
					<colgroup>
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 15%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col />
						<col v-if="user.company_id != 'jc'" style="width: 10%" />
						<col style="width: 7%" />
						<col v-if="user.company_id == 'jc'" style="width: 3%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
					</colgroup>
					<thead>
						<tr>
							<th>Arrive Date</th>
							<th>Vendor</th>
							<th>Vendor</th>
							<th>BL No</th>
							<th>Carton</th>
							<th>{{ headers.class }}</th>
							<th>{{ headers.class }} Description</th>
							<th v-if="user.company_id != 'jc'">Color</th>
							<th>Qty</th>
							<th v-if="user.company_id == 'jc'">U/M</th>
							<th>Price</th>
							<th>amount</th>
							<th>Inv Qty</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="root !== ''">
							<template v-for="date in root.value.list">
								<template v-for="(vendor, vendorIndex) in date.list">
									<template v-for="(cls, clsIndex) in vendor.list">
										<template v-for="(item, itemIndex) in cls.list">
											<tr :key="item.itemNo">
												<td>{{ (vendorIndex === 0 && clsIndex === 0 && itemIndex === 0 ? date.date : '') | moment('MM-DD-yyyy') }}</td>
												<td>{{ clsIndex === 0 && itemIndex === 0 ? vendor.vendorCode : '' }}</td>
												<td>{{ clsIndex === 0 && itemIndex === 0 ? vendor.vendorName : '' }}</td>
												<td>
													<a href="javascript:void(0)" @click="shipmentGo(vendor.shNo)" v-if="clsIndex === 0 && itemIndex === 0">{{ vendor.sh_dn }}</a>
												</td>
												<td class="al_right">{{ clsIndex === 0 && itemIndex === 0 ? vendor.carton : '' }}</td>
												<td>{{ itemIndex === 0 ? cls.classCode : '' }}</td>
												<td>{{ itemIndex === 0 ? cls.className : '' }}</td>
												<td v-if="user.company_id != 'jc'">{{ item.colorCode }}</td>
												<td class="al_right">{{ item.qty | commaSeparated }}</td>
												<td v-if="user.company_id == 'jc'" class="al_center">{{ item.purchaseUnitCode }}</td>
												<td class="al_right">{{ item.price | toCurrency }}</td>
												<td class="al_right">{{ item.amount | toCurrency }}</td>
												<td class="al_right">{{ item.onHand | commaSeparated }}</td>
											</tr>
										</template>
									</template>
								</template>
							</template>
							<tr>
								<td colspan="4" class="al_right">TOTAL</td>

								<td class="al_right">{{ root.value.carton | commaSeparated }}</td>
								<td></td>
								<td></td>
								<td v-if="user.company_id != 'jc'"></td>
								<td class="al_right">{{ root.value.qty | commaSeparated }}</td>
								<td v-if="user.company_id == 'jc'"></td>
								<td></td>
								<td class="al_right">{{ root.value.amount | toCurrency }}</td>
								<td></td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="Excel">Excel</a>
				</li>
				<li v-if="user.company_id == 'jc'">
					<a href="javascript:void(0);" @click="sheet()">Sheet</a>
				</li>
			</ul>
		</div>

		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { daysAdd, daysAgo, today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { objectToFormData, shipmentPageGo } from '@/api/util';
import { apiPreReceiving } from '@/api/purchase/purchase';
import XLSX from 'xlsx-js-style';
import { defaultDataType } from 'export-xlsx';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';

export default {
	props: ['headers'],
	data: function() {
		return {
			fromDate: today(),
			toDate: daysAdd(7),
			vendorCode: null,
			classCode: null,
			carton: null,
			root: {
				value: {
					carton: '',
					amount: '',
					qty: '',
				},
			},
			itemClassList: [],

			sheet_popup: null, // #3312
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		PartnerSelect,
		ItemClassSelect,
		SheetCopyPopup,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			this.fromDate = daysAgo(6);
			this.toDate = today();
			this.vendorCode = null;
			this.classCode = null;
			this.carton = null;
		},
		async search() {
			const paramObj = {
				fromDate: this.fromDate,
				toDate: this.toDate,
				vendorCode: this.vendorCode,
				classCode: this.classCode,
				carton: this.carton,
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiPreReceiving(param);

			this.root = data;
		},

		Excel() {
			this.$nextTick(function() {
				const elt = document.getElementById('output');
				const wb = XLSX.utils.table_to_book(elt, { raw: true });
				return XLSX.writeFile(wb, 'Pre_Receiving_' + this.fromDate + '_' + this.toDate + '.xlsx');
			});
		},
		shipmentGo(sh_no) {
			shipmentPageGo(sh_no);
		},
		// #3312 JC Sheet: 화면 12열(JC 는 Color 없음, U/M 있음)과 같은 열 정의. Class 라벨은 화면처럼 headers.class 를 쓴다.
		sheetHeaders() {
			return [
				{ key: 'arrive_date', name: 'Arrive Date', dataType: defaultDataType.string },
				{ key: 'vendor_code', name: 'Vendor', dataType: defaultDataType.string },
				{ key: 'vendor_name', name: 'Vendor', dataType: defaultDataType.string },
				{ key: 'sh_dn', name: 'BL No', dataType: defaultDataType.string },
				{ key: 'carton', name: 'Carton', dataType: defaultDataType.number },
				{ key: 'class_code', name: this.headers.class, dataType: defaultDataType.string },
				{ key: 'class_name', name: this.headers.class + ' Description', dataType: defaultDataType.string },
				{ key: 'qty', name: 'Qty', dataType: defaultDataType.number },
				{ key: 'purchase_unit_code', name: 'U/M', dataType: defaultDataType.string },
				{ key: 'price', name: 'Price', dataType: defaultDataType.currency },
				{ key: 'amount', name: 'amount', dataType: defaultDataType.currency },
				{ key: 'on_hand', name: 'Inv Qty', dataType: defaultDataType.number },
			];
		},
		// 화면 표는 날짜·거래처·BL·Carton·Class 를 첫 행에만 보여주지만, 매크로 붙여넣기용 Sheet 는 모든 행에 채운다. 날짜는 화면 필터와 같은 MM-DD-YYYY.
		sheetRows(root) {
			const records = [];
			if (!root || !root.value || !Array.isArray(root.value.list)) return records;
			root.value.list.forEach(date => {
				const arrive_date = date.date ? this.$moment(date.date).format('MM-DD-YYYY') : '';
				(date.list || []).forEach(vendor => {
					(vendor.list || []).forEach(cls => {
						(cls.list || []).forEach(item => {
							records.push({
								arrive_date,
								vendor_code: vendor.vendorCode,
								vendor_name: vendor.vendorName,
								sh_dn: vendor.sh_dn,
								carton: vendor.carton,
								class_code: cls.classCode,
								class_name: cls.className,
								qty: item.qty,
								purchase_unit_code: item.purchaseUnitCode,
								price: item.price,
								amount: item.amount,
								on_hand: item.onHand,
							});
						});
					});
				});
			});
			return records;
		},
		// #3312 Sheet: 마지막 조회 결과를 평탄화하고, 헤더 아래 합계 행은 API 집계(carton·qty·amount)를 그대로 쓴다.
		sheet() {
			if (this.root === '' || !this.root || !this.root.value || !Array.isArray(this.root.value.list)) {
				this.$toast.error('Please search first');
				return false;
			}
			this.sheet_popup = {
				title: 'Pre Receiving List (Sheet)',
				headers: this.sheetHeaders(),
				rows: this.sheetRows(this.root),
				options: { total_row: { sh_dn: 'TOTAL', carton: this.root.value.carton, qty: this.root.value.qty, amount: this.root.value.amount } },
			};
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_PreReceiving');
		this.$store.commit('setSubTitle', 'Purchase -> Pre Receiving List');
	},
};
</script>

<style></style>
